/**
 * 새 버전 감지 (spec 2026-09-24 PWA · 2026-09-29 탭 틀 §6.6) — 의존 없는 작은 모듈이라
 * 탭 틀(workspace-shell.js)이 pwa.js 의 모듈 그래프를 끌어오지 않고 쓴다.
 */

// 이 문서가 받은 정적 파일의 버전(서버 pwaStaticState, head 의 meta)과 지금 워커의 버전을 비교한다 (리뷰 #2).
function pageVersion() {
    const m = document.querySelector('meta[name="pwa-version"]');
    return (m && m.content) || '';
}

function workerVersion(worker) {
    return new Promise((resolve) => {
        if (!worker) { resolve(''); return; }
        const ch = new MessageChannel();
        const timer = setTimeout(() => resolve(''), 3000);
        ch.port1.onmessage = (e) => { clearTimeout(timer); resolve((e.data && e.data.version) || ''); };
        try { worker.postMessage({ type: 'version' }, [ch.port2]); } catch (err) { clearTimeout(timer); resolve(''); }
    });
}

// 새 워커가 페이지를 넘겨받아도(skipWaiting + clients.claim) 이 문서가 이미 그 버전이면 알리지 않는다 —
// 배포 뒤 첫 이동은 네트워크에서 새 화면을 받은 뒤에 새 워커가 설치된다. 처음 설치(컨트롤러 없던 페이지)도 조용하다.
// 탭 틀(workspace-shell.js)도 같은 판정으로 제 알림을 띄운다.
export function watchPwaUpdate(onUpdate) {
    if (!('serviceWorker' in navigator)) return;
    let hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        const was = hadController;
        hadController = true;
        if (!was) return;
        workerVersion(navigator.serviceWorker.controller).then((v) => {
            const mine = pageVersion();
            if (v && mine && v !== mine) onUpdate();
        });
    });
}

